import { useQsFilters } from "@dash/filters";

import { FulfillmentOrderFilters, fulfillmentOrderFiltersSerializer } from "@megaron/megarax-uri";
import { OrderDisplayFinancialStatus, OrderDisplayFulfillmentStatus } from "@megaron/shopify";

import { nonPalletDeliveryValues } from "./OrdersFilters";

export type OrdersFiltersType = FulfillmentOrderFilters;

export const useOrdersFilters = () => {
  const defaultFilters: OrdersFiltersType = {
    page: 0,
    fulfillmentStatus: [
      OrderDisplayFulfillmentStatus.PartiallyFulfilled,
      OrderDisplayFulfillmentStatus.Unfulfilled,
      OrderDisplayFulfillmentStatus.InProgress,
    ],
    financialStatus: [OrderDisplayFinancialStatus.Paid],
    deliveryMethod: nonPalletDeliveryValues,
    isCancelled: false,
  };

  const { filters, setFilters } = useQsFilters(fulfillmentOrderFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof OrdersFiltersType>(key: K) =>
    (value: OrdersFiltersType[K]) =>
      setFilters({ ...filters, [key]: value });

  return { filters, setFilter, setFilters, defaultFilters };
};
